import { openDB } from "idb";

const DB_NAME = "path-intelligent";
const DB_VERSION = 1;
const MAX_CASES = 20;

let _dbPromise = null;

function getDB() {
  if (!_dbPromise) {
    _dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains("cases")) db.createObjectStore("cases", { keyPath: "id" });
        if (!db.objectStoreNames.contains("reports")) db.createObjectStore("reports", { keyPath: "id" });
        if (!db.objectStoreNames.contains("pending_annotations"))
          db.createObjectStore("pending_annotations", { keyPath: "id", autoIncrement: true });
      },
    });
  }
  return _dbPromise;
}

export async function cacheCase(caseData) {
  if (!caseData || !caseData.id) return;
  const db = await getDB();
  await db.put("cases", { ...caseData, cached_at: new Date().toISOString() });
  const all = await db.getAll("cases");
  if (all.length > MAX_CASES) {
    all.sort((a, b) => new Date(a.cached_at) - new Date(b.cached_at));
    for (let i = 0; i < all.length - MAX_CASES; i++) await db.delete("cases", all[i].id);
  }
}

export async function getCachedCases() {
  const db = await getDB();
  const all = await db.getAll("cases");
  return all.sort((a, b) => new Date(b.cached_at) - new Date(a.cached_at));
}

export async function getCachedCase(id) {
  const db = await getDB();
  return db.get("cases", id);
}

// Purge complète (déconnexion — exigence Loi 25 : aucune donnée de santé résiduelle)
export async function clearOfflineCache() {
  try {
    const db = await getDB();
    await Promise.all(["cases", "reports", "pending_annotations"].map((s) => db.clear(s)));
  } catch (e) { /* ignore */ }
  try {
    if (window.caches) {
      const keys = await caches.keys();
      await Promise.all(keys.filter((k) => k.startsWith("api-")).map((k) => caches.delete(k)));
    }
  } catch (e) { /* ignore */ }
}
